import React from 'react';
import { Helmet } from 'react-helmet';

import ChatbotBusinessForm from '../components/forms/ChatbotBusinessForm';
import Layout from '../components/layout';


export default function ChatbotBusinessQuestionnairePage({ location }) {

  return (
    <Layout location={location} isDarkNav isChatbotNav noFooterMargin>
      <Helmet>
        <title>
          AI Chatbot Intake Form
        </title>
        <meta
          name='description'
          content="In order to build your chatbot, we just need a little more detail about your business. Fill out this form before your demo to see what we can do for you!"
        />
      </Helmet>
      <ChatbotBusinessForm />
    </Layout>
  );
}
